import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);

document.addEventListener('DOMContentLoaded', () => {
  const swipers = document.querySelectorAll('.wp-block-nf-blocks-slider>.swiper-container');
  
  /**
   * There are probably many different slider styles on one page 
   * so i have to initialize them individually and also provide 
   * a unique selector for scrollbar & pagination
   */
  swipers.forEach( (element, index) => {

    const uniqueClass = "nfb-swiper-" + index;
    element.classList.add(uniqueClass);

    const autoplay = Number( element.getAttribute("data-swiper-autoplay") ) > 0 ? { delay: element.getAttribute("data-swiper-autoplay") } : false;
    const fade = element.getAttribute("data-swiper-fade") !== ('false' || undefined) ? true : false;

    new Swiper( '.' + uniqueClass, {
      autoplay: autoplay,
      effect: fade ? 'fade' : 'slide',
      speed: fade ? 1500 : 400,

      pagination: {
        el: '.' + uniqueClass + ' .swiper-pagination',
        bulletActiveClass: 'swiper-pagination-bullet-active has-primary-background-color',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.' + uniqueClass + ' .swiper-scrollbar',
        dragClass: 'swiper-scrollbar-drag has-primary-background-color'
      },
    });
  } )
  
})